import { CategoricalDonut } from '../../Common/Charts/CategoricalDonut';
import { usePacientProfileChartsDataContext } from './hooks/usePacientProfileChartsDataContext';
import { coresMescladasArray } from '../../Common/styles/colors';

const SEX_COLORS = {
    Masculino: '#0D82D3',
    Feminino: '#D6588F',
    'Não informado': '#90A4AE',
    Ignorado: '#B0BEC5'
};

export const PatientBySex = () => {
    const { chartData } = usePacientProfileChartsDataContext();

    const porSexo = chartData?.bySex || [];
    const subtitles = porSexo.map((item) => item.sexo);
    const values = porSexo.map((item) => item.total);
    const colors = subtitles.map((label, index) =>
        SEX_COLORS[label] || coresMescladasArray[index % coresMescladasArray.length]
    );

    return (
        <CategoricalDonut
            title={'Distribuição por Sexo'}
            values={values}
            subtitles={subtitles}
            colors={colors}
        />
    );
};
